import { render, staticRenderFns } from "./SumarProduktVariant.vue?vue&type=template&id=a0396e50&"
import script from "./SumarProduktVariant.vue?vue&type=script&lang=js&"
export * from "./SumarProduktVariant.vue?vue&type=script&lang=js&"
import style0 from "./SumarProduktVariant.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VOverlay,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0396e50')) {
      api.createRecord('a0396e50', component.options)
    } else {
      api.reload('a0396e50', component.options)
    }
    module.hot.accept("./SumarProduktVariant.vue?vue&type=template&id=a0396e50&", function () {
      api.rerender('a0396e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pripady_wizard/SumarProduktVariant.vue"
export default component.exports